<template>
  <validation-observer
    v-if="isUserKeepMeSignIn"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="user-keep-sign-in"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row :is-vertical-splitted="isColumnLayout">
        <form-section-label slot="label">
          <span
            class="mr-1"
            v-html="keepMeSignedInText.title"
          />
          <qz-tooltip
            v-if="keepMeSignedInText.helpText"
            bottom
          >
            <template #tooltip-body>
              <span
                v-html="keepMeSignedInText.helpText"
              />
            </template>
          </qz-tooltip>
        </form-section-label>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_user-keep-sign-in`"
          name="Outbound"
          rules="required"
        >
          <checkbox-square
            v-model="questionData.userKeepSignIn"
            :name="`${stepId}.user_keep_sign_in`"
            :data-test="snakeCase(questionFields.userKeepSignIn)"
            :error="failed"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import QzTooltip from '@/components/QzTooltip/QzTooltip';
import { inject } from '@vue/composition-api';

export default {
  name: 'question-user-keep-sign-in',
  extends: QuestionBase,
  components: {
    QzTooltip,
  },
  data () {
    return {
      fields: ['userKeepSignIn'],
    };
  },
  setup () {
    const {
      keepMeSignedInText,
      hiddenQuestions,
      partnerSignin,
    } = inject('config');
    const isUserKeepMeSignIn = partnerSignin && hiddenQuestions['user-keep-me-sign-in'] === 0;

    return {
      keepMeSignedInText,
      isUserKeepMeSignIn,
    };
  },
};
</script>
